import { createSlice } from '@reduxjs/toolkit'
import {addToParty} from "../api/addtoparty";

export const secretSantaSlice = createSlice({
    name: 'secretSantaInfo',
    initialState: null,
    reducers: {
        add: (state, action) => {
            switch (action.type) {
                case 'secretSantaInfo/add': {
                    const updatedPayload = {
                        ...action.payload,
                        Gifts: action.payload.Gifts || [],
                        PartyId: 1
                    }
                    addToParty(updatedPayload).then(r => r);
                }
            }
        }
    }
})

export const { add } = secretSantaSlice.actions;

export default secretSantaSlice.reducer